/**
 * Loads the export workbook module on demand. `expo export --platform web`
 * splits this `import()` into its own chunk, so exceljs is only downloaded
 * when someone exports. This is the only place `../export` may be imported
 * from app code; a static import would pull exceljs into the main bundle.
 */
export function loadExport(): Promise<typeof import("../export")> {
  return import("../export");
}
